export default __webpack_public_path__ + "static/media/header-V60.ea8d4c7d.jpg";